import React from "react";
import "./navBar.css";
import logo from "../../Assets/BlackSwanLogo.png";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import useViewport from "../../Common/GetViewPort";
import { GiHamburgerMenu } from "react-icons/gi";
import { GrClose } from "react-icons/gr";
import logoSignature from "../../Assets/LogoSignature.png";
import logoBlack from "../../Assets/BlackSwanLogoBlack.png";

import { RiArrowDropUpFill, RiArrowDropDownFill } from "react-icons/ri";
import { MdLanguage } from "react-icons/md";
import i18next from "i18next";
import { IoIosArrowDown, IoIosArrowUp } from "react-icons/io";
const NavBar = (props) => {
  const t = props.language;
  const navigate = useNavigate();
  const width = useViewport().width;
  // const [openMenu, setOpenMenu] = useState(false);
  const [first, setFirst] = useState(false);
  const [second, setSecond] = useState(false);
  const [third, setThird] = useState(false);
  const [fourth, setFourth] = useState(false);
  const [fifth, setFifth] = useState(false);
  const [languageMenu, setLanguageMenu] = useState(false);
  const [bsrec, setBsrec] = useState(false);
  const [reference, setReference] = useState(false);
  const [valeurs, setValeurs] = useState(false);
  const [actus, setActus] = useState(false);
  const [contact, setContact] = useState(false);

  let openMenu = props.openMenu;
  return (
    <nav className="navbar" id="navbar">
      <div className="wrapper">
        {width > 1150 ? (
          <div className="navbar__text">
            <div className="left__navbar--side">
              <img
                src={props.black ? logoBlack : logo}
                className="navbar__logo"
                alt="logo"
                onClick={() => {
                  navigate(`/`);
                }}
              ></img>
            </div>
            <div className="right__navbar--side">
              <div
                className="left__dropdown"
                onMouseEnter={() => {
                  setBsrec(true);
                }}
                onMouseLeave={() => {
                  setBsrec(false);
                }}
              >
                <span
                  className="hover-effect"
                  style={props.black ? { color: "black" } : { color: "white" }}
                >
                  {t("about_us")}
                  <IoIosArrowDown
                    className={bsrec ? "upArrow--nav" : "downArrow--nav"}
                  />
                </span>
                {bsrec ? (
                  <div className="left__menu--dropdown">
                    <a
                      href="#who-we-are"
                      onClick={() => {
                        navigate(`/#who-we-are`);
                      }}
                    >
                      {t("about_us")}
                    </a>
                    <a
                      href="#know-how"
                      onClick={() => {
                        navigate(`/#know-how`);
                      }}
                    >
                      {t("kh")}
                    </a>
                    <a
                      href="#team"
                      onClick={() => {
                        navigate(`/#team`);
                      }}
                    >
                      {t("team")}
                    </a>
                    <a
                      href="#partners"
                      onClick={() => {
                        navigate(`/#partners`);
                      }}
                    >
                      {t("partners")}
                    </a>
                    {/* <a
                      href="#"
                      onClick={() => {
                        navigate(`/#`);
                      }}
                    >
                      {t("join_us")}
                    </a> */}
                  </div>
                ) : (
                  ""
                )}
              </div>
              <div
                className="left__dropdown"
                onMouseEnter={() => {
                  setReference(true);
                }}
                onMouseLeave={() => {
                  setReference(false);
                }}
              >
                <span
                  className="hover-effect"
                  style={props.black ? { color: "black" } : { color: "white" }}
                  onClick={() => {
                    navigate("/our-portfolio");
                  }}
                >
                  {t("our_portfolio")}
                  {/* <IoIosArrowDown
                    className={reference ? "upArrow--nav" : "downArrow--nav"}
                  /> */}
                </span>
                {/* {reference ? (
                  <div className="left__menu--dropdown">
                    <span>Track Record</span>
                  </div>
                ) : (
                  ""
                )} */}
              </div>
              <div
                className={`left__dropdown`}
                onMouseEnter={() => {
                  setValeurs(true);
                }}
                onMouseLeave={() => {
                  setValeurs(false);
                }}
              >
                <span
                  className="hover-effect"
                  style={props.black ? { color: "black" } : { color: "white" }}
                  onClick={() => {
                    navigate("/our-values");
                  }}
                >
                  {t("our_values")}{" "}
                </span>
              </div>
              <div
                className="left__dropdown"
                onMouseEnter={() => {
                  setActus(true);
                }}
                onMouseLeave={() => {
                  setActus(false);
                }}
              >
                <span
                  className="hover-effect"
                  style={props.black ? { color: "black" } : { color: "white" }}
                  onClick={() => {
                    navigate("/news");
                  }}
                >
                  {t("news")}
                </span>
              </div>
              <div
                className="left__dropdown"
                onMouseEnter={() => {
                  setContact(true);
                }}
                onMouseLeave={() => {
                  setContact(false);
                }}
              >
                <span
                  className="hover-effect"
                  style={props.black ? { color: "black" } : { color: "white" }}
                  onClick={() => {
                    navigate("/get-in-touch");
                  }}
                >
                  {t("contact_us")}{" "}
                </span>
              </div>
              <div className="language__wrap ">
                <span
                  className="language"
                  style={props.black ? { color: "black" } : { color: "white" }}
                  // onMouseEnter={() => {
                  //   setLanguageMenu(true);
                  // }}
                  // onMouseLeave={() => {
                  //   setLanguageMenu(false);
                  // }}
                  onClick={() => {
                    setLanguageMenu(!languageMenu);
                  }}
                >
                  <MdLanguage className="globe__lng" />
                  {/* <RiArrowDropDownFill className="arrow_drop" /> */}
                </span>
                {languageMenu ? (
                  <div
                    className="languages"
                    // onMouseEnter={() => {
                    //   setLanguageMenu(true);
                    // }}
                    // onMouseLeave={() => {
                    //   setLanguageMenu(false);
                    // }}
                    onClick={() => {
                      setLanguageMenu(!languageMenu);
                    }}
                  >
                    {props.languages.map(({ code, name, country_code }) => (
                      <button
                        key={country_code}
                        onClick={() => {
                          i18next.changeLanguage(code);
                          setLanguageMenu(false);
                        }}
                      >
                        {name.slice(0, 2).toUpperCase()}
                      </button>
                    ))}
                  </div>
                ) : (
                  <div></div>
                )}
              </div>
            </div>
          </div>
        ) : (
          <div>
            {!openMenu ? (
              <div className="navbar__text">
                <div className="left__navbar--side">
                  <img
                    src={props.black ? logoBlack : logo}
                    className="navbar__logo"
                    alt="logo"
                    onClick={() => {
                      navigate(`/`);
                    }}
                  ></img>
                </div>
                <div className="rightside__nav">
                  <div className="dropdown">
                    <div className="language__wrap">
                      <span
                        className="language"
                        // onMouseEnter={() => {
                        //   setLanguageMenu(true);
                        // }}
                        // onMouseLeave={() => {
                        //   setLanguageMenu(false);
                        // }}
                        onClick={() => {
                          setLanguageMenu(!languageMenu);
                        }}
                      >
                        <MdLanguage
                          className="globe__lng"
                          style={
                            props.black
                              ? { color: "black" }
                              : { color: "white" }
                          }
                        />
                        {/* <RiArrowDropDownFill className="arrow_drop" /> */}
                      </span>
                      {languageMenu ? (
                        <div
                          className="languages"
                          // onMouseEnter={() => {
                          //   setLanguageMenu(true);
                          // }}
                          // onMouseLeave={() => {
                          //   setLanguageMenu(false);
                          // }}
                          onClick={() => {
                            setLanguageMenu(!languageMenu);
                          }}
                        >
                          {props.languages.map(
                            ({ code, name, country_code }) => (
                              <button
                                key={country_code}
                                onClick={() => {
                                  i18next.changeLanguage(code);
                                  setLanguageMenu(false);
                                }}
                              >
                                {name.slice(0, 2).toUpperCase()}
                              </button>
                            )
                          )}
                        </div>
                      ) : (
                        <div></div>
                      )}
                    </div>
                  </div>
                  <div className="hamburger__background">
                    <GiHamburgerMenu
                      className="navbar__menu"
                      style={
                        props.black ? { color: "black" } : { color: "white" }
                      }
                      onClick={(e) => {
                        // setOpenMenu(!openMenu);
                        props.onOpen(!openMenu);
                      }}
                    />
                  </div>
                </div>
              </div>
            ) : (
              <div></div>
            )}
          </div>
        )}
        {openMenu ? (
          <div className="menu">
            <div className="menu__header">
              <img
                src={logoSignature}
                alt="logo"
                className="menu__logo"
                onClick={() => {
                  navigate(`/`);
                }}
              />
              <div
                className="hamburger__background"
                style={{ background: "white" }}
                onClick={() => {
                  // setOpenMenu(!openMenu);
                  props.onOpen(!openMenu);
                }}
              >
                <GrClose className="menu__close" />
              </div>
            </div>
            <div className="menu__text">
              <div>
                <div
                  className="menu__div"
                  onClick={() => {
                    setFirst(!first);
                  }}
                >
                  Black Swan
                  {!first ? (
                    <IoIosArrowDown className="arrow" />
                  ) : (
                    <IoIosArrowUp className="arrow" />
                  )}
                </div>
                {first ? (
                  <div className="submenu">
                    <a
                      href="#who-we-are"
                      onClick={() => {
                        navigate(`/#who-we-are`);
                        props.onOpen(!openMenu);
                      }}
                    >
                      {t("about_us")}
                    </a>
                    <a
                      href="#"
                      onClick={() => {
                        navigate(`/#`);
                        props.onOpen(!openMenu);
                      }}
                    >
                      {t("kh")}
                    </a>
                    <a
                      href="#team"
                      onClick={() => {
                        navigate(`/#team`);
                        props.onOpen(!openMenu);
                      }}
                    >
                      {t("team")}
                    </a>
                    <a
                      href="#partners"
                      onClick={() => {
                        navigate(`/#partners`);
                        props.onOpen(!openMenu);
                      }}
                    >
                      {t("partners")}
                    </a>
                  </div>
                ) : (
                  <div></div>
                )}
              </div>
              <div>
                <div
                  className="menu__div"
                  onClick={() => {
                    navigate("/our-portfolio");
                    props.onOpen(!openMenu);
                  }}
                >
                  {t("our_portfolio")}
                  {/* {!second ? (
                    <RiArrowDropDownFill className="arrow" />
                  ) : (
                    <RiArrowDropUpFill className="arrow" />
                  )} */}
                </div>
                {/* {second ? (
                  <div className="submenu">
                    <a
                      href=""
                      onClick={() => {
                        props.onOpen(!openMenu);
                      }}
                    >
                      Track record
                    </a>
                  </div>
                ) : (
                  <div></div>
                )} */}
              </div>
              <div>
                <div
                  className="menu__div"
                  onClick={() => {
                    navigate("/our-values");
                    props.onOpen(!openMenu);
                  }}
                >
                  {t("our_values")}
                </div>
              </div>
              <div>
                <div
                  className="menu__div"
                  onClick={() => {
                    navigate("/news");
                    props.onOpen(!openMenu);
                  }}
                >
                  {t("news")}
                </div>
              </div>
              <div>
                <div
                  className="menu__div"
                  onClick={() => {
                    navigate("/get-in-touch");
                    props.onOpen(!openMenu);
                  }}
                >
                  {t("contact_us")}
                </div>
              </div>
            </div>
          </div>
        ) : (
          <></>
        )}
      </div>
    </nav>
  );
};

export default NavBar;
